var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"wrapper",staticClass:"vertical-container",class:{
    'is-editing': _vm.isEditing
  }},[_vm._t("default"),_c('ButtonsContainer',{attrs:{"fill-width":!_vm.narrowSingleButton}},[_vm._t("buttons")],2),_c('resize-observer',{on:{"notify":_vm.emitHeight}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }